import React from 'react';
import ChevronRightArrow from '../assets/images/ChevronRight.svg';

export default () => {
  return <img src={ChevronRightArrow} alt="" />;
};
